// extracted by mini-css-extract-plugin
module.exports = {"box":"CaseHistory_box__1sB2p","title":"CaseHistory_title__2-Ssm","strongTitle":"CaseHistory_strongTitle__fblGD","dateTitle":"CaseHistory_dateTitle__1NdlM"};